export const reachConstants = {
  FETCH_ESTIMATED_REACH: 'FETCH_ESTIMATED_REACH',
  SET_ESTIMATED_REACH: 'SET_ESTIMATED_REACH',
  SET_REACH_PARAMETERS: 'SET_REACH_PARAMETERS',
  RESET_REACH_STORE: 'RESET_REACH_STORE',
  SET_IS_FETCHING_REACH: 'SET_IS_FETCHING_REACH',
  SET_IS_SHOWING_REACH: 'SET_IS_SHOWING_REACH',
  SET_HAS_FETCH_ERROR: 'SET_HAS_FETCH_ERROR',
};
